import type { ReactNode } from 'react';
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';

export interface PageHeadingProps {
  scope: string;
  target?: string;
  badge?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  readOnly?: boolean;
}

/**
 * Velzon page-title-box. Keeps the original API (scope/target/badge/meta/
 * actions/readOnly) — only the markup moved to Bootstrap/reactstrap.
 */
export function PageHeading({ scope, target, badge, meta, actions, readOnly }: PageHeadingProps) {
  return (
    <Row>
      <Col xs={12}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 d-flex align-items-baseline gap-2">
            {scope}
            {target && <span className="text-primary font-monospace">{target}</span>}
            {badge}
            {readOnly && (
              <span className="badge bg-info-subtle text-info">Sola lettura</span>
            )}
          </h4>

          <div className="page-title-right d-flex align-items-center gap-3 flex-wrap">
            {meta && (
              <div className="text-muted small d-flex align-items-center gap-3">{meta}</div>
            )}
            {actions ? (
              <div className="d-flex gap-2">{actions}</div>
            ) : (
              <Breadcrumb listClassName="mb-0">
                <BreadcrumbItem>t/picking</BreadcrumbItem>
                <BreadcrumbItem active>{target ?? scope}</BreadcrumbItem>
              </Breadcrumb>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
}
